var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"faqMarker"}},[_c('h2',{staticClass:"instH2"},[_vm._v("Ответы на вопросы")]),_c('ul',_vm._l((_vm.faq),function(item,index){return _c('faqItem',{key:index,attrs:{"item":item}})}),1),_c('docLinkDesc',{attrs:{"id":'instTxtDesc'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }